import { api } from "@services/api";
import type { NormalGatepassRequestPayload } from "./gatepass/types";

export const submitGatepassRequest = async ({
  service,
  payload,
  transactionId,
}: {
  service: string;
  payload: NormalGatepassRequestPayload; // add all gatepass types
  transactionId?: string;
}) => {
  return api.post(
    service,
    "gatepass-requests:start",
    payload,
    ...(transactionId ? [{ transactionId }] : []),
  );
};

export interface VesselLookupPayload {
  imoNumber?: number;
  name?: string;
}

export interface VesselLookupResponse {
  imoNumber?: number;
  name?: string;
}

export const lookupVesselByImo = async ({
  service,
  payload,
}: {
  service: string;
  payload: VesselLookupPayload;
}) => {
  return api.post<VesselLookupResponse>(service, "gatepass-requests/vessels/lookup", payload);
};

export const getGatepassPrintDocument = async ({
  service,
  id,
}: {
  service: string;
  id: string;
}): Promise<Blob> => {
  return api.get(service, `/gatepass-requests/${id}:print`, {
    responseType: "blob",
  });
};
